import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'app-single-image-upload',
  templateUrl: './single-image-upload.component.html',
  styleUrl: './single-image-upload.component.scss'
})
export class SingleImageUploadComponent {
  @Input() selectedImage: string | null = null;
  @Output() fileSelected = new EventEmitter<File>();

  isDragging = false;

  onImageSelected(file: File) {
    if (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg') {
      const reader = new FileReader();
      reader.onload = () => {
        this.selectedImage = reader.result as string;
        this.fileSelected.emit(file);
      };
      reader.readAsDataURL(file);
    } else {
      console.error("File type not supported");
    }
  }

  handleFileInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.onImageSelected(input.files[0]);
    }
  }

  handleDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    if (event.dataTransfer?.files.length) {
      this.onImageSelected(event.dataTransfer.files[0]);
    }
  }

  handleDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  handleDragLeave() {
    this.isDragging = false;
  }

  removeImage() {
    this.selectedImage = null;
    this.fileSelected.emit(null as any);
  }
}
